import { combineReducers } from 'redux';
import training from './training.reducer';
import recordings from './recordings.reducer';

const reducer = combineReducers({
	training,
	recordings
});

export default reducer;
